import { AnyAction, Reducer } from 'redux'

import { RefinanciamentoTypes } from '@store/refinanciamento/actions'

import { DadosPessoaisState, DadosPessoaisTypes } from './types'

const INITIAL_STATE: DadosPessoaisState = {
  userNameDadosPessoais: undefined,
  cpfDadosPessoais: undefined,
  dataNascimento: '',
  contaDadosPessoais: '',
  loading: false,
  postDadosPessoaisLoading: false,
  isValidModalityAccount: null,
  correctionMode: false,
  rejectedBankAccount: null,
}

const reduceBankAccountCorrection = (
  state: DadosPessoaisState,
  action: AnyAction,
): DadosPessoaisState | undefined => {
  switch (action.type) {
    case DadosPessoaisTypes.SET_BANK_ACCOUNT_CORRECTION_MODE:
      return { ...state, correctionMode: action.payload }
    case DadosPessoaisTypes.SET_REJECTED_BANK_ACCOUNT:
      return { ...state, rejectedBankAccount: action.payload }
    case DadosPessoaisTypes.CLEAR_BANK_ACCOUNT_CORRECTION:
      return { ...state, correctionMode: false, rejectedBankAccount: null }
    default:
      return undefined
  }
}

const reducer: Reducer<DadosPessoaisState> = (state = INITIAL_STATE, action) => {
  const correctionState = reduceBankAccountCorrection(state, action)
  if (correctionState) {
    return correctionState
  }

  switch (action.type) {
    case DadosPessoaisTypes.SET_USER_NAME_DADOS_PESSOAIS:
      return { ...state, userNameDadosPessoais: action.payload }
    case DadosPessoaisTypes.SET_CPF_DADOS_PESSOAIS:
      return { ...state, cpfDadosPessoais: action.payload }
    case DadosPessoaisTypes.SET_DATA_NASCIMENTO:
      return { ...state, dataNascimento: action.payload }
    case DadosPessoaisTypes.SET_CONTA_DADOS_PESSOAIS:
      return { ...state, contaDadosPessoais: action.payload }
    case DadosPessoaisTypes.GET_DADOS_PESSOAIS_REQUEST:
      return { ...state, loading: true }
    case DadosPessoaisTypes.GET_DADOS_PESSOAIS_SUCCESS:
      return { ...state, loading: false }
    case DadosPessoaisTypes.GET_DADOS_PESSOAIS_ERROR:
      return { ...state, loading: false }
    case DadosPessoaisTypes.RESET_DADOS_PESSOAIS_LOADING:
      return { ...state, loading: false }
    case DadosPessoaisTypes.SET_HAS_ENDERECO:
      return { ...state, hasEndereco: action.payload }
    case DadosPessoaisTypes.SET_HAS_DADOS_BANCARIOS:
      return { ...state, hasDadosBancarios: action.payload }
    case DadosPessoaisTypes.SET_IS_VALID_MODALITY_ACCOUNT:
      return { ...state, isValidModalityAccount: action.payload }
    case DadosPessoaisTypes.SET_POST_DADOS_PESSOAIS_LOADING:
      return { ...state, postDadosPessoaisLoading: action.payload }
    case RefinanciamentoTypes.RESET:
      return { ...INITIAL_STATE }
    default:
      return state
  }
}

export default reducer
